import(/* webpackMode: "eager" */ "/var/www/html/Ariel/src/app/page.tsx");
